// Helpers
import { apiInstance, gql } from "@/services/httpAdapter";
import { errorLogger } from "@Common/helpers/logger";

// Types
import { GraphqlQueryResponse } from "@Common/api/types/GraphqlQueryResponse";
import { IDraw } from "@DataPages/types/draw/models";

export async function ingestDraws(locationId: string, commissionCycleId: string, payPeriodId: string) {
	const query = gql`
		mutation ingestDraws($locationId: String!, $commissionCycleId: String!, $payPeriodId: String!) {
			ingestDraws(locationId: $locationId, commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId) {
				_id
				locationId
				commissionCycleId
				payPeriodId
				draws {
					drawItems {
						drawType
						amount
					}
					user {
						_id
						fullName
						position
					}
				}
				createdAt
				updatedAt
			}
		}
	`;

	const variables = {
		commissionCycleId,
		locationId,
		payPeriodId,
	};

	try {
		const response: GraphqlQueryResponse<"ingestDraws", IDraw> = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.ingestDraws;
	} catch (err) {
		errorLogger(err as Error, { function: "drawsIngestion", message: "Failed to ingest draws", variables });
		return null;
	}
}
